import React, { FunctionComponent, ReactNode } from 'react';
import { ThemedFunctor } from '@doveit/bricks';
import * as styles from './PageLayoutAside.style';

export interface PageLayoutAsideProps {
  size?: string,
  addCss?: ThemedFunctor,
  desktopOrder?: number,
  children: ReactNode,
}

const PageLayoutAside: FunctionComponent<PageLayoutAsideProps> = ({
  size = '21.5rem',
  addCss,
  desktopOrder,
  children,
  ...rest
}) => (
  <aside
    css={styles.aside}
    $addCss={addCss}
    $order={desktopOrder}
    $size={size}
    {...rest}
  >
    {children}
  </aside>
);

export default PageLayoutAside;
